var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLeaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.5 322.2",
    style: {
      enableBackground: "new 0 0 236.5 322.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#519259;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2.7,
    y: 9.3,
    width: 229.3,
    height: 306
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6,296.1l83.9-84c27.4-27.5,27.4-72.1,0-99.6l-65.6-65.8l-65.6,65.8c-27.4,27.5-27.4,72.1,0,99.6 L72,231.9c0,0,38.7-38.3,39.8-39.9c3.5-5,5.4-10.7,5.8-16.6c0.8,0.7,1.6,1.4,2.4,2.2c11.3,11.3,12.5,28.9,3.7,41.6l-50.4,50.5 L73,270l-42-41.9c-36.2-36.3-36.2-95.4,0-131.7l86.8-86.9l86.8,86.9c36.2,36.3,36.2,95.4,0,131.7L117.8,315l-18.6-18.6 L99.6,296.1z M75.8,142.1c-0.1,0.1-0.2,0.2-0.3,0.3c-9.4,9.8-9.9,24.9-1.5,35.3c0.6,0.7,1.2,1.4,1.8,2l42.9-43l42.9,43 c10.4-10.4,10.4-27.2,0-37.6l-42.7-42.8l-0.2,0.2l-0.2-0.2L75.8,142.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeaf);
export default __webpack_public_path__ + "static/media/logo-leaf.c7653aa70f38a544ef0458299ca745ff.svg";
export { ForwardRef as ReactComponent };